import * as stagesCase from "../../Stages/StagesCase";
import { getRequiredFields, validateFields } from "../statusChangeValidators";
import { LitigationUnion } from "../../../types/LitigationUnion";
import dayjs from "dayjs";

export const abstractLitigationCaseValidators = {
  [stagesCase.STAGE_CREATED]: (abstractLitigationCase: LitigationUnion) =>
    validateFields(getRequiredFields(abstractLitigationCase, stagesCase.STAGE_CREATED), abstractLitigationCase),
  [stagesCase.STAGE_DATA_COMPLETED]: (abstractLitigationCase: LitigationUnion) =>
    validateFields(getRequiredFields(abstractLitigationCase, stagesCase.STAGE_DATA_COMPLETED), abstractLitigationCase),
  [stagesCase.STAGE_WAITING_FOR_FEEDBACK]: () => [], // this stage is not supposed to have any validators, even though it has required fields
  [stagesCase.STAGE_DATA_COMPLETED_LAWFIRM]: (abstractLitigationCase: LitigationUnion) =>
    validateFields(
      getRequiredFields(abstractLitigationCase, stagesCase.STAGE_DATA_COMPLETED_LAWFIRM),
      abstractLitigationCase
    ),
  [stagesCase.STAGE_CHECKED]: (abstractLitigationCase: LitigationUnion) =>
    validateFields(getRequiredFields(abstractLitigationCase, stagesCase.STAGE_CHECKED), abstractLitigationCase),
  [stagesCase.STAGE_IN_PROGRESS]: (abstractLitigationCase: LitigationUnion) =>
    validateFields(getRequiredFields(abstractLitigationCase, stagesCase.STAGE_IN_PROGRESS), abstractLitigationCase),
  [stagesCase.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT]: (abstractLitigationCase: LitigationUnion) =>
    validateFields(
      getRequiredFields(abstractLitigationCase, stagesCase.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT),
      abstractLitigationCase
    ),
  [stagesCase.STAGE_EXTRAJUDICIAL_REACTION_RECEIVED]: (abstractLitigationCase: LitigationUnion) =>
    validateFields(
      getRequiredFields(abstractLitigationCase, stagesCase.STAGE_EXTRAJUDICIAL_REACTION_RECEIVED),
      abstractLitigationCase
    ),
  [stagesCase.STAGE_ACTION_REQUIRED]: (abstractLitigationCase: LitigationUnion) =>
    validateFields(getRequiredFields(abstractLitigationCase, stagesCase.STAGE_ACTION_REQUIRED), abstractLitigationCase),
  [stagesCase.STAGE_PREPARE_LAWSUIT]: (abstractLitigationCase: LitigationUnion) => {
    let errorMessages = validateFields(
      getRequiredFields(abstractLitigationCase, stagesCase.STAGE_PREPARE_LAWSUIT),
      abstractLitigationCase
    );

    if (
      abstractLitigationCase.caseCategory === "defendClaim" &&
      !abstractLitigationCase.paymentOrderDate &&
      !abstractLitigationCase.enforcementOrderDate &&
      !abstractLitigationCase.statementOfClaimFiledDate
    ) {
      errorMessages.push(
        "Es muss entweder Datum des Mahnbescheids, Datum des Vollstreckungsbescheids oder Klage erhalten am ausgefüllt sein."
      );
    }

    return errorMessages;
  },
  [stagesCase.STAGE_LAWSUIT]: (abstractLitigationCase: LitigationUnion) => {
    let errorMessages = validateFields(
      getRequiredFields(abstractLitigationCase, stagesCase.STAGE_LAWSUIT),
      abstractLitigationCase
    );
    if (
      abstractLitigationCase.paymentType === "insurance" &&
      abstractLitigationCase.caseInsurance.judicialCoverageGranted !== true
    ) {
      errorMessages.push("Die gerichtliche Deckung muss gegeben sein");
    }
    return errorMessages;
  },
  [stagesCase.STAGE_TRIAL]: (abstractLitigationCase: LitigationUnion) =>
    validateFields(getRequiredFields(abstractLitigationCase, stagesCase.STAGE_TRIAL), abstractLitigationCase),
  [stagesCase.STAGE_EVALUATE_JUDGEMENT]: () => true,
  [stagesCase.STAGE_LAWSUIT_COMPLETED]: (abstractLitigationCase: LitigationUnion) => {
    let errorMessages = validateFields(
      getRequiredFields(abstractLitigationCase, stagesCase.STAGE_LAWSUIT_COMPLETED),
      abstractLitigationCase
    );

    if (
      abstractLitigationCase.lawsuitCompletedReason === "defaultJudgement" &&
      dayjs().isBefore(dayjs(abstractLitigationCase.lawsuitCompletedDate))
    ) {
      errorMessages.push("Das Versäumnisurteil muss rechtskräftig sein (Rechtskräftiges VU am)");
    }

    return errorMessages;
  },
  [stagesCase.STAGE_COMPLETED]: (abstractLitigationCase: LitigationUnion) => {
    return validateFields(
      getRequiredFields(abstractLitigationCase, stagesCase.STAGE_COMPLETED),
      abstractLitigationCase
    );
  },
};
